import type {IFilterOption} from '../../types/galleryTypes';

export const spreadChoiceGroup = (option: IFilterOption): string[] => {
  const id = option.id ?? option.key;
  if (option.childIds?.length) {
    return [id, ...option.childIds];
  }
  return [id];
};

export const spreadSelectedChoiceGroups = (activeOptions: string[], allOptions: IFilterOption[]): string[] => {
  return activeOptions
    .map((optionKey) => allOptions.find((o) => o.key === optionKey))
    .filter(Boolean)
    .flatMap(spreadChoiceGroup);
};
